import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'react-toastify/dist/ReactToastify.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import './bbraun.css'
import './index.css'
import store from './store'
import { fetchLanguages, fetchUsers, validateToken } from './store/actions'
import { Provider } from 'react-redux'
import { getItem, removeItem } from './utils/localStorage'
import { CookiesProvider } from 'react-cookie'


const renderApplication = () => {
    ReactDOM.render(
        <CookiesProvider>
            <Provider store={store}>
                <App/>
            </Provider>
        </CookiesProvider>,
        document.getElementById('root')
    )
}

const token = getItem('token')
if (!!token) {
    Promise.resolve()
        .then(() => store.dispatch(validateToken(token)))
        .then(({ payload }) => {
            if (!payload.user) {
                removeItem('token')
                return Promise.resolve(null)
            }
            return Promise.all([store.dispatch(fetchLanguages()), store.dispatch(fetchUsers())])
        })
        .then(renderApplication)
        .catch(() => {
            ReactDOM.render(
                <div>
                    <h1>Ein Fehler ist aufgetreten</h1>
                </div>,
                document.getElementById('root')
            )
        })
} else {
    renderApplication()
}



// WEBPACK FOOTER //
// ./src/index.js